// @flow
import api from 'api'
import Loading from 'components/Loading'
import ModalFormUnavailable from 'components/Modal/ModalFormUnavailable'
import * as React from 'react'
import { useHistory, useParams } from 'react-router'
import { toast } from 'react-toastify'
import PatientForm from 'ui/organisms/PatientForm'
import { hasText } from 'utils/helpers'
import { ZentakeContext } from 'utils/ZentakeContext'

function KioskModeMain(): React.Node {
  const history = useHistory()
  const { slug } = useParams()

  const { setKioskModeLockDown, userDetails } = React.useContext(ZentakeContext)

  const [formName, setFormName] = React.useState('')
  const [teamId, setTeamId] = React.useState(null)
  const [isPacket, setIsPacket] = React.useState(false)
  const [enabled, setEnabled] = React.useState(true)
  const [hasNoResponse, setHasNoResponse] = React.useState(false)

  React.useEffect(() => {
    if (!userDetails?.is_verified) {
      history.push('/forms')
      toast.warning('Verify Email')
    } else {
      setKioskModeLockDown(true)
    }
  }, [history, setKioskModeLockDown, userDetails?.is_verified])

  React.useEffect(() => {
    async function getFormName() {
      let form = null
      try {
        form = await api.getForm(slug)
      } catch (error) {}
      if (form?.name) {
        setFormName(form.name)
        // setFormName(form.text || form.name)
        setTeamId(form.team?.uid)
        setEnabled(form.enabled)
      } else {
        try {
          const packet = await api.getPacket(slug)
          if (packet?.name) {
            setFormName(packet.name)
            setIsPacket(true)
            setTeamId(packet.team?.uid)
            setEnabled(packet.enabled)
          } else {
            setHasNoResponse(true)
          }
        } catch (error) {
          setHasNoResponse(true)
        }
      }
    }
    getFormName()
  }, [slug])

  const startForm = React.useCallback(
    async (user) => {
      if (!user) return

      const newMessage = await api.createKioskFormMessage(user.id, slug, teamId)
      history.push(
        `/r/${newMessage?.response?.id}?isKiosk=true&response_type=form`
      )
    },
    [history, slug, teamId]
  )

  const startPacket = React.useCallback(
    async (user) => {
      if (!user) return

      const newMessage = await api.createKioskPacketMessage(
        user.id,
        slug,
        teamId
      )
      history.push(
        `/r/${newMessage?.packet_response?.id}?isKiosk=true&response_type=packet`
      )
    },
    [history, slug, teamId]
  )

  const onSubmit = async (user: ?{ id: string }) => {
    isPacket ? startPacket(user) : startForm(user)
  }

  if (hasNoResponse || (hasText(formName) && !enabled)) {
    return (
      <ModalFormUnavailable
        hideButton
        isVisible
        description="Sorry, this form is not available anymore"
        title="Form not available"
      />
    )
  }

  if (!hasText(formName)) {
    return <Loading />
  }

  return (
    <PatientForm
      messageType="kiosk_response"
      onSubmit={onSubmit}
      resourceId={slug}
      resourceType={isPacket ? 'packet' : 'form'}
      title={formName}
    />
  )
}

export default KioskModeMain
